import { SearchListItem, SearchList } from './searchList';
import { SuggestedCategory as SuggestedCategoryModel } from 'models/SuggestedCategory';
import styles from './styles.scss';
import { hasElements } from 'utils';

export interface SuggestedCategoryProps extends SuggestedCategoryModel {
  reset: () => void;
  className?: string;
  showSubCategories?: boolean;
}

export const SuggestedCategory = (props: SuggestedCategoryProps) => (
  <>
    <SearchListItem className={styles.suggestedCategory} {...props}>
      {props.displayName}&nbsp;
      {props.parentCategoryDisplayName && (
        <span className={styles.parentCategory}>({props.parentCategoryDisplayName})</span>
      )}
    </SearchListItem>
    {props.showSubCategories && hasElements(props.categories) && (
      <li className={styles.subcategories}>
        <SearchList>
          {props.categories.map(category => (
            <SuggestedCategory key={category.id} reset={props.reset} {...category} />
          ))}
        </SearchList>
      </li>
    )}
  </>
);
